var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "el_dialog",
      attrs: {
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "報告書商品明細別進捗管理一覧（清掃）",
        top: "5vh",
        width: "900px",
        visible: _vm.dialogVisible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "vab-form",
        { ref: "form", attrs: { model: _vm.formObject, rules: _vm.rulesDay } },
        [
          _c(
            "div",
            { staticClass: "flex_space margin_bottom_7 flex_align_end" },
            [
              _c("div", { staticClass: "flex_center_align" }, [
                _c("div", { staticClass: "split_line" }),
                _c("div", { staticClass: "box_title" }, [_vm._v("PS課処理")]),
              ]),
              _c("vab-button", { attrs: { "btn-list": _vm.btnListRt } }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "sure_box top_info mtn" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_c("div", [_vm._v("報告書到着日")])]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box word_box_690 word_box_imp",
                      attrs: { span: 20 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_center_align" },
                        [
                          _c("vab-date-picker", {
                            staticClass: "vab_picker margin_0",
                            attrs: {
                              type: "date",
                              "value-format": "yyyy/MM/dd",
                              format: "yyyy/MM/dd",
                              prop: "reportArrivaiDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [
                      _c("div", [
                        _vm._v("不具合報告欄チェック（アピール加点）"),
                      ]),
                    ]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box word_box_690 nopadding",
                      attrs: { span: 20 },
                    },
                    [
                      _c(
                        "vab-row",
                        [
                          _c(
                            "vab-col",
                            {
                              staticClass: "word_box word_box_imp",
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_center_align" },
                                [
                                  _c("vab-checkbox", {
                                    staticClass: "margin_0",
                                    attrs: {
                                      label: "特別清掃提案書",
                                      nullable: true,
                                    },
                                  }),
                                  _c("vab-checkbox", {
                                    staticClass: "margin_0 margin_left_16",
                                    attrs: {
                                      label: "アピール加点",
                                      nullable: true,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        [
                          _c(
                            "vab-col",
                            {
                              staticClass: "word_box word_box_imp",
                              staticStyle: { border: "none" },
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_start" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "clo_right_span textarea_span flex_center flex_align",
                                    },
                                    [_vm._v(" メモ ")]
                                  ),
                                  _c("vab-textarea", {
                                    staticClass:
                                      "vab_textarea clo_textarea margin_0",
                                    attrs: {
                                      type: "textarea",
                                      prop: "comment",
                                      rows: "5",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "flex_center_align",
              staticStyle: { margin: "17px 0 7px 0" },
            },
            [
              _c("div", { staticClass: "split_line" }),
              _c("span", { staticClass: "box_title" }, [_vm._v("作業情報")]),
            ]
          ),
          _c(
            "div",
            { staticClass: "sure_box top_info mtn" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("作業名称")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "flex_center_align word_box word_box_265",
                      attrs: { span: 8 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(_vm._s(_vm.formObject.wrknm)),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("発注No連番")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box word_box_265 flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formObject.acceptOrderNoSeq) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("建物")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box word_box_265 flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(" " + _vm._s(_vm.formObject.blgsnmkj) + " "),
                          ]),
                          _c("div", { staticClass: "sub_title" }, [
                            _vm._v(
                              "（建物CD：" +
                                _vm._s(_vm.formObject.blgscd) +
                                "）"
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("所属部門")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box word_box_265 flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(_vm._s(_vm.formObject.orgkj)),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("協力会社")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box word_box_265 flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(_vm._s(_vm.formObject.bcnfrkj)),
                          ]),
                          _c("div", { staticClass: "sub_title" }, [
                            _vm._v(
                              " （協力会社CD：" +
                                _vm._s(_vm.formObject.hcccd) +
                                "） "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("作業予定日")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box word_box_265 flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formObject.wpdtmin) +
                                " ~ " +
                                _vm._s(_vm.formObject.wrkendpltm) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("作業実施日")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass:
                        "word_box word_box_690 word_box_imp flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formObject.wxdtmin) +
                                " ~ " +
                                _vm._s(_vm.formObject.wrkendtm) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer flex_end mg12",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "flex_start flex_center_align" },
            [
              _c("div", { staticClass: "cancel", on: { click: _vm.close } }, [
                _vm._v("キャンセル"),
              ]),
              _c("vab-button", { attrs: { "btn-list": _vm.btnList } }),
            ],
            1
          ),
        ]
      ),
      _c("PopupChildren", {
        attrs: {
          visible2: _vm.visibleChildren,
          list: _vm.popChildrenList,
          "visible-children": _vm.visibleChildren,
        },
        on: {
          "update:visibleChildren": function ($event) {
            _vm.visibleChildren = $event
          },
          "update:visible-children": function ($event) {
            _vm.visibleChildren = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }